import React from 'react';
import { LegacyStack, Text } from '@shopify/polaris';
import { Util } from '@thinkwell/react.common';
import { AppProvider } from '@thinkwell/react.polaris';

export default function Maintenance(props) {
  Util.hideLoader();

  return (<AppProvider>
    <LegacyStack distribution="center">
      <Text variant="headingMd" as="p">
        {props.message || 'Maintenance - please try again later'}
      </Text>
    </LegacyStack>
  </AppProvider>)
}
